import { FC, ReactNode } from "react"
import { Container, Typography } from "@mui/material"
import { useTitle } from "@/core/hooks"

interface IProps {
  title: string
  children?: ReactNode
}

/** Общая обёртка страниц модуля «График присутствия». */
export const StaffSchedulePage: FC<IProps> = ({ title, children }) => {
  useTitle(`Персонал — ${title}`)
  return (
    <Container maxWidth={false}>
      <Typography variant="h5" mb={2}>
        {title}
      </Typography>
      {children}
    </Container>
  )
}
